export default __webpack_public_path__ + "static/media/icon_settingtype_Bar.b8381355.png";